export const whatIsCabelGateway = [
  {
    id: "90.123.29.119",
    type: "default",
    position: { x: 320, y: 200 },
    className: "gateway",
    data: { label: "90.123.29.119" },
    dragHandle: "noDrag",
  },
  {
    id: "126.134.35.41",
    type: "default",
    position: { x: 520, y: 200 },
    className: "gateway",
    data: { label: "126.134.35.41" },
    dragHandle: "noDrag",
  },
  {
    id: "71dd::ad48:7474:3412",
    type: "default",
    position: { x: 320, y: 400 },
    className: "gateway",
    data: { label: "71dd::ad48:7474:3412" },
    dragHandle: "noDrag",
  },
  {
    id: "224.109.172.5",
    type: "default",
    position: { x: 520, y: 400 },
    className: "gateway",
    data: { label: "224.109.172.5" },
    dragHandle: "noDrag",
  },
];
